"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFooter = createFooter;

var _solidUi = require("solid-ui");

/**
 * links in the footer
*/
var SOLID_PROJECT_URL = 'https://solidproject.org';
var SOLID_PROJECT_NAME = 'solidproject.org';

function createFooter(store) {
  (0, _solidUi.initFooter)(store, setFooterOptions());
}

function setFooterOptions() {
  return {
    solidProjectUrl: SOLID_PROJECT_URL,
    solidProjectName: SOLID_PROJECT_NAME
  };
}
//# sourceMappingURL=footer.js.map